var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RadioWidget as _RadioWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var RadioWidget = (function (_super) {
    __extends(RadioWidget, _super);
    function RadioWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = [];
        return _this;
    }
    RadioWidget.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
        this.setupOptions();
    };
    RadioWidget.prototype.setupOptions = function () {
        var _this = this;
        this.options = this.schema.enum.map(function (value, index) { return ({
            value: value,
            label: _this.schema.options.enum_titles[index],
        }); });
    };
    Object.defineProperty(RadioWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return RadioWidget;
}(_RadioWidget));
export { RadioWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/radio.widget.ts.pre-build-optimizer.js